import React from 'react';
import { AcademyLive } from 'store/modules/academy_store/types';
import { Container } from './styles';

interface AcademyContentCardProps {
  content: AcademyLive;
  onPlay: (content: AcademyLive) => void;
}

const AcademyContentCard: React.FC<AcademyContentCardProps> = ({ content, onPlay }) => {
  return (
    <Container type="button" onClick={() => onPlay(content)}>
      <div className="thumb">
        {content.thumbnail_url && <img src={content.thumbnail_url} alt={content.title} />}
        <span className="play-overlay">
          <i className="material-icons">play_circle_filled</i>
        </span>
      </div>
      <div className="body">
        <div className="title">{content.title}</div>
        {content.speaker && <div className="subtitle">{content.speaker}</div>}
        {content.content_type && <span className="type-pill">{content.content_type}</span>}
      </div>
    </Container>
  );
};

export default AcademyContentCard;
